/*!

=========================================================
* Argon Dashboard React - v1.2.2
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { useLocation, Route, Switch, Redirect } from "react-router-dom";
// reactstrap components
import { Container } from "reactstrap";
// core components
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import Sidebar from "components/Navbars/Sidebar.js";

import routes from "routes.js";
import Palette from "utils/Palette";


const Admin = (props) => {
  const mainContent = React.useRef(null);
  const location = useLocation();

  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContent.current.scrollTop = 0;
  }, [location]);

  const getRoutes = (routes) => {
    let rute = routes.map((prop, key) => {
      if (prop.layout === "/admin") {
        return (
          <Route
            path={prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
    return rute
  };

  const getBrandText = (path) => {
    for (let i = 0; i < routes.length; i++) {
      if (
        props.location.pathname.indexOf(routes[i].layout + routes[i].path) !==
        -1
      ) {
        return routes[i].name;
      }
    }
    return "Brand";
  };

  return (
    <>
      <Sidebar
        {...props}
        routes={routes}
        logo={{
          innerLink: "/admin/index",
          imgSrc: require("../assets/img/brand/Logo_ReadIndonesia.png"),
          imgAlt: "..."
        }}
      />
      <div className="main-content" ref={mainContent} style={{paddingTop : 80, background : Palette.BACKGROUND_DARK_GRAY, height: "100dvh"}}>
        <AdminNavbar
          {...props}
          brandText={getBrandText(props.location.pathname)}
        />

        {/*<Container*/}

        {/*    fluid>*/}
          <div
              style={{
                display: "flex",
                flexGrow: 1,
              background: Palette.BACKGROUND_DARK_GRAY
              }}
          >
            <Switch>
              {getRoutes(routes)}
              <Redirect from="/" to="/books" />
              {/* <Route path={"*"} component={Dashboard}/> */}
            </Switch>
          </div>
          {/* <Container fluid>
              <AdminFooter />
          </Container> */}
        {/*</Container>*/}
      </div>
    </>
  );
};

export default Admin;
